// extracted by mini-css-extract-plugin
export default {"editAction":"edit-action_editAction__H0V8H"};